<app-navbar *ngIf="toggleNavSVC.visible"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="toggleNavSVC.visible"></app-footer>